import React from 'react'
import numberHelper from '../../util/numberFormatter'
import dateHelper from '../../util/dateFormatter'
import ReactModal from 'react-modal'
import { Link } from 'react-router-dom'
import { Translation } from 'react-i18next'
import i18n from '../../languages/lang.js'

class LogList extends React.Component {
  constructor() {
    super()
    this.state = {
      showModal: false
    }
  }
  getParent = () => {
    return document.querySelector('#logs')
  }
  openModal = (item) => {
    this.setState({ showModal: true })
    Object.assign(this.state, {
      created: item.created,
      details: JSON.stringify(item.variable),
      type: item.type,
      ip: item.ip,
      agent: item.agent
    })
  }

  closeModal = () => {
    this.setState({ showModal: false })
    Object.assign(this.state, {
      created: '',
      details: '',
      type: '',
      ip: '',
      agent: ''
    })
  }

  render() {
    if (!this.props.data) {
      return (
        <Translation>
          {
            (t) => (
              <div className={'loading'}>{t('system.loading')}</div>
            )
          }
        </Translation>
      )
    }

    if (this.props.data.length === 0) {
      return (
        <Translation>
          {
            (t) => (
              <div className={'initial'}>
                {t('system.empty_data')}
              </div>
            )
          }
        </Translation>
      )
    }
    const created = this.state.created
    const details = this.state.details
    const type = this.state.type
    const agent = this.state.agent
    const ip = this.state.ip
    return (
      <Translation>
        {
          (t) => (
            <div id='logs' >
              <table className="table-list-small">
                <thead>
                  <tr>
                    <th>{t('file.label_created')}</th>
                    <th>{t('file.action')}</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.props.data.map(item => {
                      return (
                        <tr key={item.key}>
                          <td className="sub">
                            <span onClick={() => this.openModal(item)}>{dateHelper.Formatter.toLocalString(item.created)}</span>
                          </td>
                          <td className="sub">
                            <span onClick={() => this.openModal(item)}>{item.type.replace('.', ' ')}</span>
                          </td>
                        </tr>
                      )
                    })
                  }
                </tbody>
              </table>
              <ReactModal isOpen={this.state.showModal} parentSelector={this.getParent}>
                <div id="content-clear">
                  <div className="focus-wrap">
                    <div className='box-header'>
                      <span className='header-info'>{t('file.label_created')}: {dateHelper.Formatter.toLocalString(created)}</span>
                      <h2>{t('file.log_detail_title')}</h2>
                    </div>
                    <dl className='content-details content-details-alt'>
                      <dt>{t('file.label_details')}</dt>
                      <dd>{details}</dd>
                    </dl>
                    <dl className='content-details content-details-alt'>
                      <dt>{t('file.label_type')}</dt>
                      <dd>{type}</dd>
                      <dt>{t('file.label_ip')}</dt>
                      <dd>{ip}</dd>
                      <dt>{t('file.label_agent')}</dt>
                      <dd>{agent}</dd>
                    </dl>
                    <hr />
                    <div id='tool-belt'>
                      <a href='#' onClick={this.closeModal}>{t('file.close_button')}</a>
                    </div>
                  </div>
                </div>
              </ReactModal>
            </div>
          )
        }
      </Translation>
    )
  }
}

export default LogList
